"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullComponent = void 0;
exports.addHttpClientToSchema = addHttpClientToSchema;
exports.getAllowedColumnsByTypes = getAllowedColumnsByTypes;
const ramda_1 = require("ramda");
const NullComponent = () => null;
exports.NullComponent = NullComponent;
function addHttpClientToSchema(scheme, path, httpClient) {
    const field = (0, ramda_1.view)((0, ramda_1.lensPath)(path), scheme);
    if (field)
        field['ui:httpClient'] = httpClient;
}
function getAllowedColumnsByTypes(columns, types) {
    var _a;
    return (_a = columns === null || columns === void 0 ? void 0 : columns.filter((c) => types.includes(c.type))) !== null && _a !== void 0 ? _a : [];
}
//# sourceMappingURL=utils.js.map